// A mapping's nickname is its permanent id (the Redis key, the webhook URL
// /ingest/webhook/<nickname>, and what `zagentc import --mapping` takes), so it
// cannot be renamed after creation - the setup wizards therefore ask for it up
// front. Left blank, a random `<prefix>-xxxxxxxx` handle is generated as before.

const ALLOWED = /[^a-z0-9_-]/g;

// "  My Infra! " -> "@my-infra"; "" (or nothing usable) -> "".
export function normalizeNickname(input: string): string {
  const body = input
    .trim()
    .replace(/^@+/, '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(ALLOWED, '')
    .replace(/-{2,}/g, '-')
    .replace(/^[-_]+|[-_]+$/g, '');
  return body ? `@${body.slice(0, 40)}` : '';
}

export function resolveNickname(input: string, fallbackPrefix: string, randomSuffix: string): string {
  return normalizeNickname(input) || `${fallbackPrefix}-${randomSuffix}`;
}
